import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from '../components/Layout.jsx';
import { api, getUser } from '../api.js';

const ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'recepcion', label: 'Recepción' },
  { value: 'camarera', label: 'Camarera' },
  { value: 'contador', label: 'Contador' },
];

export default function AdminUsuarios() {
  const me = getUser();
  if (me?.rol !== 'admin') return <Navigate to="/" replace />;

  const [usuarios, setUsuarios] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ nombre: '', pin: '', rol: 'recepcion' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  const cargar = async () => {
    const r = await api.usuarios();
    setUsuarios(r.usuarios);
  };
  useEffect(() => { cargar(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (form.pin.length < 4) {
      setMsg('PIN debe tener al menos 4 dígitos.');
      return;
    }
    setLoading(true);
    setMsg('');
    try {
      await api.crearUsuario(form);
      setForm({ nombre: '', pin: '', rol: 'recepcion' });
      setShowForm(false);
      await cargar();
    } catch (err) {
      setMsg('Error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="mb-8 flex items-end justify-between">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted mb-2">Administración</div>
          <h1 className="text-4xl font-bold tracking-tight">Usuarios</h1>
        </div>
        <button onClick={() => setShowForm((s) => !s)} className="btn-primary">
          {showForm ? 'Cancelar' : '+ Nuevo usuario'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={submit} className="card mb-6 grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="md:col-span-2">
            <label className="label">Nombre</label>
            <input className="input" value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required />
          </div>
          <div>
            <label className="label">PIN (4-6 dígitos)</label>
            <input className="input" type="password" inputMode="numeric" minLength={4} maxLength={6} value={form.pin} onChange={(e) => setForm({ ...form, pin: e.target.value })} required />
          </div>
          <div>
            <label className="label">Rol</label>
            <select className="input" value={form.rol} onChange={(e) => setForm({ ...form, rol: e.target.value })}>
              {ROLES.map((r) => (
                <option key={r.value} value={r.value}>{r.label}</option>
              ))}
            </select>
          </div>
          {msg && <div className="md:col-span-4 text-sm text-red-700 font-mono">{msg}</div>}
          <div className="md:col-span-4">
            <button className="btn-accent" disabled={loading}>{loading ? 'Guardando…' : 'Crear usuario'}</button>
          </div>
        </form>
      )}

      <div className="card overflow-x-auto">
        <table className="w-full min-w-[480px]">
          <thead>
            <tr className="text-left">
              <th className="label pb-3">Nombre</th>
              <th className="label pb-3">Rol</th>
              <th className="label pb-3 text-right">Estado</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((u) => (
              <tr key={u.id} className="border-t border-line">
                <td className="py-3 font-medium tracking-tight">{u.nombre}</td>
                <td className="py-3 font-mono text-xs uppercase tracking-[0.14em] text-muted">{u.rol}</td>
                <td className="py-3 text-right">
                  <span className={`pill ${u.activo ? 'bg-lime/30' : 'bg-bone'}`}>{u.activo ? 'Activo' : 'Inactivo'}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
